import React from 'react';

import AccountGroupRenderer from './accountGroupRenderer.component';
import CTTGroupRenderer from './cttGroupRenderer.component';
import { GroupRendererPropTypes } from './proptypes';

const GroupRowHeader = ({
  rowData,
  ibtAmount,
  tagName,
  account,
  isOpen,
  toggle,
  suppressHidingDecimalPlacesForPercentage,
  hideGroupingColumns,
  displayGroupingColumnsByPercentages,
}) => {
  const isLastInBranch = !rowData.subrows.length;
  return (
    <div>
      { rowData.descr
        && (<AccountGroupRenderer
          rowData={rowData}
          ibtAmount={ibtAmount}
          tagName={tagName}
          isOpen={isOpen}
          toggle={toggle}
          suppressHidingDecimalPlacesForPercentage={suppressHidingDecimalPlacesForPercentage}
          isLastInBranch={isLastInBranch}
          hideGroupingColumns={hideGroupingColumns}
        />)}
      { rowData.countryTaxTypeDescription
        && (<CTTGroupRenderer
          rowData={rowData}
          ibtAmount={ibtAmount}
          tagName={tagName}
          account={account}
          isOpen={isOpen}
          toggle={toggle}
          suppressHidingDecimalPlacesForPercentage={suppressHidingDecimalPlacesForPercentage}
          hideGroupingColumns={hideGroupingColumns}
          displayGroupingColumnsByPercentages={displayGroupingColumnsByPercentages}
        />)}
    </div>
  );
};

GroupRowHeader.propTypes = GroupRendererPropTypes;

export default GroupRowHeader;
